// import React, { useState } from "react";
// import { Dropdown } from "react-bootstrap";

// export default function SellersTable({
//   sellers = [],
//   onStatusChange,
//   onVerify,
//   onDelete,
// }) {
//   const [expandedRow, setExpandedRow] = useState(null);

//   const getLicenseUrl = (path) =>
//     path
//       ? `https://auth.afrogebeya.com/uploads/licenses/${path.replace(
//           /^.*\/afrogebeya\/licenses/,
//           "",
//         )}`
//       : null;

//   if (!sellers.length) {
//     return <p className="text-center text-muted">No sellers found.</p>;
//   }

//   return (
//     <div className="overflow-auto w-100">
//       {/* ================= Desktop Table ================= */}
//       <table className="table table-hover table-sm align-middle d-none d-md-table">
//         <thead className="table-light">
//           <tr>
//             <th>Company</th>
//             <th>Owner</th>
//             <th>Email</th>
//             <th>Phone</th>
//             <th>Status</th>
//             <th>Verified</th>
//             <th>License</th>
//             <th>Created</th>
//             <th>Updated</th>
//             <th>Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {sellers.map((seller) => {
//             const licenseUrl = getLicenseUrl(seller.businessLicensePath);

//             return (
//               <tr key={seller.id}>
//                 <td>{seller.companyName || "-"}</td>
//                 <td>{seller.fullName || "-"}</td>
//                 <td>{seller.email}</td>
//                 <td>{seller.phone}</td>

//                 <td>
//                   <span
//                     className={`badge bg-${
//                       seller.status === "ACTIVE" ? "success" : "secondary"
//                     }`}
//                   >
//                     {seller.status}
//                   </span>
//                 </td>

//                 <td>
//                   <span
//                     className={`badge bg-${
//                       seller.licenseVerified ? "success" : "warning"
//                     }`}
//                   >
//                     {seller.licenseVerified ? "Yes" : "No"}
//                   </span>
//                 </td>

//                 <td>
//                   {licenseUrl ? (
//                     <a href={licenseUrl} target="_blank" rel="noreferrer">
//                       View
//                     </a>
//                   ) : (
//                     "-"
//                   )}
//                 </td>

//                 <td>
//                   {seller.createdAt
//                     ? new Date(seller.createdAt).toLocaleDateString()
//                     : "-"}
//                 </td>

//                 <td>
//                   {seller.updatedAt
//                     ? new Date(seller.updatedAt).toLocaleDateString()
//                     : "-"}
//                 </td>

//                 <td>
//                   <Dropdown align="end">
//                     <Dropdown.Toggle size="sm" variant="outline-secondary">
//                       Actions
//                     </Dropdown.Toggle>

//                     <Dropdown.Menu>
//                       <Dropdown.Item onClick={() => onStatusChange(seller.id)}>
//                         Activate / Deactivate
//                       </Dropdown.Item>

//                       {!seller.licenseVerified && (
//                         <Dropdown.Item onClick={() => onVerify(seller.id)}>
//                           Verify Seller
//                         </Dropdown.Item>
//                       )}

//                       <Dropdown.Divider />

//                       <Dropdown.Item
//                         className="text-danger"
//                         onClick={() => onDelete(seller.id)}
//                       >
//                         Delete
//                       </Dropdown.Item>
//                     </Dropdown.Menu>
//                   </Dropdown>
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>

//       {/* ================= Mobile Cards ================= */}
//       <div className="d-md-none">
//         {sellers.map((seller) => {
//           const isExpanded = expandedRow === seller.id;
//           const licenseUrl = getLicenseUrl(seller.businessLicensePath);

//           return (
//             <div key={seller.id} className="card mb-2 shadow-sm">
//               <div className="card-body">
//                 <div className="d-flex justify-content-between">
//                   <div>
//                     <h6 className="mb-1">{seller.companyName || "-"}</h6>
//                     <p className="mb-0 text-muted">{seller.email}</p>
//                   </div>
//                   <button
//                     className="btn btn-sm btn-outline-secondary"
//                     onClick={() =>
//                       setExpandedRow(isExpanded ? null : seller.id)
//                     }
//                   >
//                     {isExpanded ? "Hide" : "Details"}
//                   </button>
//                 </div>

//                 {isExpanded && (
//                   <div className="mt-2">
//                     <p>
//                       <strong>Owner:</strong> {seller.fullName || "-"}
//                     </p>
//                     <p>
//                       <strong>Phone:</strong> {seller.phone}
//                     </p>

//                     <p>
//                       <strong>Status:</strong>{" "}
//                       <span
//                         className={`badge bg-${
//                           seller.status === "ACTIVE" ? "success" : "secondary"
//                         }`}
//                       >
//                         {seller.status}
//                       </span>
//                     </p>

//                     <p>
//                       <strong>Verified:</strong>{" "}
//                       <span
//                         className={`badge bg-${
//                           seller.licenseVerified ? "success" : "warning"
//                         }`}
//                       >
//                         {seller.licenseVerified ? "Yes" : "No"}
//                       </span>
//                     </p>

//                     <p>
//                       <strong>License:</strong>{" "}
//                       {licenseUrl ? (
//                         <a href={licenseUrl} target="_blank" rel="noreferrer">
//                           View
//                         </a>
//                       ) : (
//                         "-"
//                       )}
//                     </p>

//                     <Dropdown className="mt-2">
//                       <Dropdown.Toggle
//                         size="sm"
//                         variant="outline-secondary"
//                         className="w-100"
//                       >
//                         Actions
//                       </Dropdown.Toggle>

//                       <Dropdown.Menu className="w-100">
//                         <Dropdown.Item
//                           onClick={() => onStatusChange(seller.id)}
//                         >
//                           Activate / Deactivate
//                         </Dropdown.Item>

//                         {!seller.licenseVerified && (
//                           <Dropdown.Item onClick={() => onVerify(seller.id)}>
//                             Verify Seller
//                           </Dropdown.Item>
//                         )}

//                         <Dropdown.Divider />

//                         <Dropdown.Item
//                           className="text-danger"
//                           onClick={() => onDelete(seller.id)}
//                         >
//                           Delete
//                         </Dropdown.Item>
//                       </Dropdown.Menu>
//                     </Dropdown>
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import "../../../styles/sellers-table.css";

export default function SellersTable({
  sellers = [],
  onStatusChange,
  onApprove,
  onDelete,
}) {
  const [expandedRow, setExpandedRow] = useState(null);

  const getLicenseUrl = (path) =>
    path
      ? `https://auth.afrogebeya.com/uploads/licenses/${path.replace(
          /^.*\/afrogebeya\/licenses/,
          "",
        )}`
      : null;

  if (!sellers.length) {
    return <p className="text-center text-muted">No sellers found.</p>;
  }

  const StatusBadge = ({ status }) => (
    <span
      className={`badge bg-${status === "ACTIVE" ? "success" : "secondary"}`}
    >
      {status}
    </span>
  );

  const VerifiedBadge = ({ verified }) => (
    <span className={`badge bg-${verified ? "success" : "warning"}`}>
      {verified ? "Yes" : "No"}
    </span>
  );

  return (
    <div className="">
      {/* ================= DESKTOP TABLE ================= */}
      <table className="table table-hover table-sm align-middle d-none d-md-table">
        <thead className="table-light">
          <tr>
            <th>Company</th>
            <th>Owner</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
            <th>Verified</th>
            <th>License</th>
            <th>Created</th>
            <th style={{ width: 120 }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {sellers.map((seller) => {
            const licenseUrl = getLicenseUrl(seller.businessLicensePath);

            return (
              <tr key={seller.id}>
                <td>{seller.companyName || "-"}</td>
                <td>{seller.fullName || "-"}</td>
                <td>{seller.email}</td>
                <td>{seller.phone}</td>

                <td>
                  <StatusBadge status={seller.status} />
                </td>

                <td>
                  <VerifiedBadge verified={seller.licenseVerified} />
                </td>

                <td>
                  {licenseUrl ? (
                    <a href={licenseUrl} target="_blank" rel="noreferrer">
                      View
                    </a>
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  {seller.createdAt
                    ? new Date(seller.createdAt).toLocaleDateString()
                    : "-"}
                </td>

                <td>
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      size="sm"
                      variant="outline-secondary"
                      id={`actions-${seller.id}`}
                    >
                      Actions
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => onStatusChange(seller.id)}>
                        Activate / Deactivate
                      </Dropdown.Item>

                      {!seller.licenseVerified && (
                        <Dropdown.Item onClick={() => onApprove(seller.id)}>
                          Verify Seller
                        </Dropdown.Item>
                      )}

                      <Dropdown.Divider />

                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => onDelete(seller.id)}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* ================= MOBILE CARDS ================= */}
      <div className="d-md-none">
        {sellers.map((seller) => {
          const isExpanded = expandedRow === seller.id;
          const licenseUrl = getLicenseUrl(seller.businessLicensePath);

          return (
            <div key={seller.id} className="card mb-2 shadow-sm">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1">{seller.companyName || "-"}</h6>
                    <p className="mb-0 text-muted">{seller.email}</p>
                    <p className="mb-0 text-muted">{seller.phone}</p>
                  </div>

                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() =>
                      setExpandedRow(isExpanded ? null : seller.id)
                    }
                  >
                    {isExpanded ? "Hide Details" : "View Details"}
                  </button>
                </div>

                {isExpanded && (
                  <div className="mt-3">
                    <p className="mb-1">
                      <strong>Owner:</strong> {seller.fullName || "-"}
                    </p>

                    <p className="mb-1">
                      <strong>Status:</strong>{" "}
                      <StatusBadge status={seller.status} />
                    </p>

                    <p className="mb-1">
                      <strong>Verified:</strong>{" "}
                      <VerifiedBadge verified={seller.licenseVerified} />
                    </p>

                    <p className="mb-1">
                      <strong>License:</strong>{" "}
                      {licenseUrl ? (
                        <a href={licenseUrl} target="_blank" rel="noreferrer">
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </p>

                    <p className="mb-2">
                      <strong>Created:</strong>{" "}
                      {seller.createdAt
                        ? new Date(seller.createdAt).toLocaleDateString()
                        : "-"}
                    </p>

                    <Dropdown className="w-100">
                      <Dropdown.Toggle
                        size="sm"
                        variant="outline-secondary"
                        className="w-100"
                      >
                        Actions
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="w-100">
                        <Dropdown.Item
                          onClick={() => onStatusChange(seller.id)}
                        >
                          Activate / Deactivate
                        </Dropdown.Item>

                        {!seller.licenseVerified && (
                          <Dropdown.Item onClick={() => onApprove(seller.id)}>
                            Verify Seller
                          </Dropdown.Item>
                        )}

                        <Dropdown.Divider />

                        <Dropdown.Item
                          className="text-danger"
                          onClick={() => onDelete(seller.id)}
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
